module.exports = __webpack_public_path__ + "img/content5_150_15.53d1e55d.png";